"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = __importDefault(require("assert"));
var shared_1 = __importDefault(require("./shared"));
var BufferWriter = /** @class */ (function () {
    /**
     *
     * @param {Buffer} buffer
     */
    function BufferWriter(buffer) {
        assert_1.default(Buffer.isBuffer(buffer), 'Invalid buffer.');
        this.buffer = buffer;
        this.position = 0;
    }
    /**
     *
     * @param offset The offset to seek.
     * @param origin The seek origin. True means seeking from begining. False means seeking from current position. Default is True.
     */
    BufferWriter.prototype.seek = function (offset, origin) {
        if (origin === void 0) { origin = true; }
        this.position = shared_1.default(offset, this.position, this.buffer.length, origin);
    };
    BufferWriter.prototype.writeDouble = function (value) {
        return this.writeDoubleLE(value);
    };
    BufferWriter.prototype.writeDoubleLE = function (value) {
        return this._writeXX('DoubleLE', value);
    };
    BufferWriter.prototype.writeDoubleBE = function (value) {
        return this._writeXX('DoubleBE', value);
    };
    BufferWriter.prototype.writeFloat = function (value) {
        return this.writeFloatLE(value);
    };
    BufferWriter.prototype.writeFloatLE = function (value) {
        return this._writeXX('FloatLE', value);
    };
    BufferWriter.prototype.writeFloatBE = function (value) {
        return this._writeXX('FloatBE', value);
    };
    BufferWriter.prototype.writeInt32 = function (value) {
        return this.writeInt32LE(value);
    };
    BufferWriter.prototype.writeInt32LE = function (value) {
        return this._writeXX('Int32LE', value);
    };
    BufferWriter.prototype.writeInt32BE = function (value) {
        return this._writeXX('Int32BE', value);
    };
    BufferWriter.prototype.writeUInt32 = function (value) {
        return this.writeUInt32LE(value);
    };
    BufferWriter.prototype.writeUInt32LE = function (value) {
        return this._writeXX('UInt32LE', value);
    };
    BufferWriter.prototype.writeUInt32BE = function (value) {
        return this._writeXX('UInt32BE', value);
    };
    BufferWriter.prototype.writeUInt16 = function (value) {
        return this.writeUInt16LE(value);
    };
    BufferWriter.prototype.writeUInt16LE = function (value) {
        return this._writeXX('UInt16LE', value);
    };
    BufferWriter.prototype.writeUInt16BE = function (value) {
        return this._writeXX('UInt16BE', value);
    };
    BufferWriter.prototype.writeInt16 = function (value) {
        return this.writeInt16LE(value);
    };
    BufferWriter.prototype.writeInt16LE = function (value) {
        return this._writeXX('Int16LE', value);
    };
    BufferWriter.prototype.writeInt16BE = function (value) {
        return this._writeXX('Int16BE', value);
    };
    BufferWriter.prototype.writeUInt8 = function (value) {
        return this._writeXX('UInt8', value);
    };
    BufferWriter.prototype.writeInt8 = function (value) {
        return this._writeXX('Int8', value);
    };
    BufferWriter.prototype.writeBuffer = function (buffer) {
        assert_1.default(buffer, 'Buffer cannot be null.');
        buffer.copy(this.buffer, this.position);
        this.position += buffer.length;
        return this.position;
    };
    BufferWriter.prototype.writeString = function (str, encoding) {
        if (encoding === void 0) { encoding = 'utf-8'; }
        var length = this.buffer.length - this.position;
        this.position += this.buffer.write(str, this.position, length, encoding);
        return this.position;
    };
    BufferWriter.prototype._writeXX = function (type, value) {
        this.position = this.buffer["write" + type](value, this.position);
        return this.position;
    };
    BufferWriter.prototype._checkPositive = function (number, name) {
        if (name === void 0) { name = 'Length'; }
        assert_1.default(number >= 0, name + " must be positive.");
    };
    BufferWriter.prototype._checkOffsetInRange = function (offset) {
        assert_1.default(offset >= 0 && offset <= this.buffer.length, 'Offset out of range.');
    };
    return BufferWriter;
}());
exports.default = BufferWriter;
